import { BookBadgeAddPage } from './BookBadgeAddPage'
import { withBookBadgeAddPage } from './withBookBadgeAddPage'

const ConnectedBookBadgeAddPage = withBookBadgeAddPage(BookBadgeAddPage)

export { ConnectedBookBadgeAddPage as BookBadgeAddPage }
